import * as devisConf from '@/configuration/devisConf';
import calculArrondi from '@/services/calcul/calculArrondi';

export function calculLigneCommandeRemise(ligneCommande) {
  ligneCommande.totalHt = ligneCommande.totalAvantRemise;
  if (!ligneCommande.typeRemise) return;

  const { remise, totalAvantRemise } = ligneCommande;
  switch (ligneCommande.typeRemise) {
    case devisConf.MONTANT:
      if (remise === null || remise === undefined || Number.isNaN(remise)) break;
      ligneCommande.totalHt = calculArrondi(totalAvantRemise + remise);
      break;
    case devisConf.POURCENTAGE:
      if (remise === null || remise === undefined || Number.isNaN(remise)) break;
      ligneCommande.totalHt = calculArrondi(totalAvantRemise + totalAvantRemise * remise / 100);
      break;
    default:
      break;
  }
}
